import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, catchError, map, of, tap, take } from 'rxjs';

import { maintenanceApiUrls } from '@personal-area/global/http/models';

import { MaintenanceSettings } from '../models/common';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { UserFacade } from '@personal-area/global/users/services';
import { AuthService } from '@personal-area/global/authorization/services';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private _maintenanceEnd = -1;

  private _http = inject(HttpClient);

  // Temp crutch for investigating of REGLOG-101
  private _authService = inject(AuthService);
  private _userFacade = inject(UserFacade);

  public getMaintenanceEnd(forceRequest = false): Observable<number> {
    return this._maintenanceEnd >= 0 && !forceRequest
      ? of(this._maintenanceEnd)
      : this._http
          .get<MaintenanceSettings>(maintenanceApiUrls.getSettings)
          .pipe(
            map(
              ({ apps }) =>
                apps.find(({ app_name }) => app_name === 'pa')
                  ?.maintenanceend || 0,
            ),
            catchError(() => of(0)),
            tap((maintenanceEnd) => (this._maintenanceEnd = maintenanceEnd)),
          );
  }

  public resetMaintenanceEnd(): void {
    this._maintenanceEnd = -1;
  }

  // Temp crutch for investigating of REGLOG-101
  public logUserData(accessUrl: string) {
    this._http.head(maintenanceApiUrls.getSettings, {
      params: {
        is_logged_in: this._authService.isLoggedIn.toString(),
        user_id_from_token: this._authService.authToken.userID,
        user_id_from_store: this._userFacade.loggedUser.id,
        access_url: accessUrl,
      }
    }).pipe(take(1)).subscribe()
  }
}
